import { useId, useState } from "react";
import Cropper from "react-easy-crop";
import { Minus, Plus } from "@phosphor-icons/react";
import { Button } from "react-bootstrap";
import { useLocalization } from "../../localization";
import type { PhotoCrop } from "../../services/profilePhotoCropService";

type Props = {
  image: string;
  disabled: boolean;
  onCrop: (area: PhotoCrop) => void;
  onError: () => void;
};

export default function ProfilePhotoCropper({ image, disabled, onCrop, onError }: Props) {
  const { t } = useLocalization();
  const hintId = useId();
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  return <div className="profile-photo-editor">
    <div className="profile-photo-editor-viewport" aria-disabled={disabled}>
      <Cropper image={image} crop={position} zoom={zoom} aspect={1} cropShape="round" showGrid={false}
        minZoom={1} maxZoom={3} objectFit="cover"
        onCropChange={value => { if (!disabled) setPosition(value); }}
        onZoomChange={value => { if (!disabled) setZoom(value); }}
        onCropAreaChange={(_, pixels) => onCrop(pixels)}
        mediaProps={{ alt: "", onError }}
        cropperProps={{ role: "group", "aria-label": t("Crop profile photo"), "aria-describedby": hintId, tabIndex: disabled ? -1 : 0 }} />
    </div>
    <div className="profile-photo-editor-tools">
      <Button variant="outline-secondary" disabled={disabled || zoom <= 1} aria-label="Zoom out" onClick={() => setZoom(value => Math.max(1, value - 0.25))}>
        <Minus size={20} aria-hidden="true" />
      </Button>
      <p id={hintId} className="profile-photo-setup-hint">
        Drag to position. Scroll or pinch to zoom.
        <span className="visually-hidden">Use the arrow keys to move the photo.</span>
      </p>
      <Button variant="outline-secondary" disabled={disabled || zoom >= 3} aria-label="Zoom in" onClick={() => setZoom(value => Math.min(3, value + 0.25))}>
        <Plus size={20} aria-hidden="true" />
      </Button>
    </div>
  </div>;
}
